import { Component, OnInit, Input } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Case } from '../detalhamento';
import { Detalhamento } from '../detalhamento';

@Component({
  selector: 'store-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.scss']
})
export class CasesComponent implements OnInit {

  constructor(private modalService: NgbModal) {}

  @Input()
  public detalhamento: Detalhamento;

  public cases: Case[];
  public imageUrl: string;
  public isExtensao: boolean;

  ngOnInit() {
    this.cases = this.detalhamento.cases;
    this.isExtensao = this.detalhamento.plataforma.chave === 'EXTENSAO';
  }

  open(content, e:MouseEvent, isModal: boolean) {

    if (!isModal) {
      return;
    }

    e.stopPropagation();
    e.preventDefault();

    let target = e.target as HTMLElement;
    while (target && target.tagName !== 'A') {
      target = target.parentElement;
    }
    if (target) {
      const href = (target as HTMLAnchorElement).href;
      this.imageUrl = href;
    }
    this.modalService.open(content, { centered: true, size: 'xl' })
  }

}
